import axios from "axios";
import _axios, { fileAxios } from "../api";

export const getUserList = async (userType, qry) =>
  await _axios.get(`/admin/${userType}/list/${qry}`).then((response) => {
    return response.data;
  });

export const getAuthorityUserList = async (qry) =>
  await _axios.get(`/authority/User/${qry}`).then((response) => {
    return response.data;
  });

export const deleteUsers = async (id, value) =>
  await _axios.post(`/admin/delete/${id}/${value}`).then((response) => {
    return response.data;
  });

export const isActiveAuthority = async (id, value) =>
  await _axios.post(`/admin/isactive/${id}/${value}`).then((response) => {
    return response.data;
  });

export const addUser = async (webUserModel) => {
  const formData = new FormData();

  Object.keys(webUserModel).forEach((key) => {
    if (key !== "councilLogo" && webUserModel[key] !== undefined && webUserModel[key] !== null) {
      formData.append(key, webUserModel[key]);
    }
  });

  // Logo File
  if (webUserModel.councilLogo?.[0]?.file) {
    formData.append("councilLogo", webUserModel.councilLogo[0].file);
  }

  const response = await fileAxios.post("/admin/add", formData);

  return response.data;
};
export const getIndividualUser = async (id) =>
  await _axios.get(`/admin/edit/${id}`).then((response) => {
    return response.data;
  });

export const updateUser = async (webUserModel) => {
  const formData = new FormData();

  Object.keys(webUserModel).forEach((key) => {
    const value = webUserModel[key];

    if (key !== "councilLogo" && value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        value.forEach((id) => {
          formData.append(key, id);
        });
      } else {
        formData.append(key, value);
      }
    }
  });

  if (webUserModel.councilLogo?.[0]?.file) {
    formData.append("councilLogo", webUserModel.councilLogo[0].file);
  }

  const response = await fileAxios.post("/admin/update", formData);
  return response.data;
};

export const modeUsers = async (theme) =>
  await _axios.post(`/mode/${theme}`).then((response) => {
    return response.data;
  });

export const getPostCodeList = async (obj) => {
  try {
    const response = await axios.get(
      `https://in8it.com/WebService/GetPostcodeList?postCode=${obj.postCode}&access_code=dNK8J34Kmn7geUj`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching postcode list:", error);
    throw error;
  }
};
